export const getName = (user: User) => {
    if (!user.firstName && !user.lastName) {
        return user.displayName ?? '';
    }
    return `${user.firstName} ${user.lastName}`;
};

export const getRoleNames = (user: User) => {
    return user.roles.map(r => r.name).sort().join(', ') || '';
};


// WEBPACK FOOTER //
// ./src/utils/user.ts